import _ from "lodash";
import italian from "@/italian";
import english from "@/english";
import spanish from "@/spanish";
import sessionStore from "@/stores/session";

const t = (key, language, subs = {}, pluralizeValue = 2) => {
  if (!language) {
    language = sessionStore.language || "it";
  }

  const langs = {
    it: italian,
    en: english,
    es: spanish,
  };

  var t = langs[language][key];

  if (!t) {
    console.warn(`Missing translation for key: ${key}`);

    return key; // "missing translation";
  }

  if (Object.keys(subs).length > 0) {
    _.each(subs, (sub, key) => {
      t = t.replace(`{${key}}`, sub);
    });
  }

  if (pluralizeValue === 1) {
    t = t.replace(/p{(\w+)\/(\w+)}/i, (match, m1) => m1);
  } else {
    t = t.replace(/p{(\w+)\/(\w+)}/i, (match, m1, m2) => m2);
  }

  return t;
};

export default t;

export const getAccountTypeTranslation = (accountType) => {
  return {
    TRANSACTIONAL: t("delivery.accounts.show.detailInfo.type.transactional"),
    NEWSLETTER: t("delivery.accounts.show.detailInfo.type.promotional"),
  }[accountType.toUpperCase()];
};

export const getLanguage = () => sessionStore.language;
